import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { SSRConfig } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { cleanObject } from '@/lib/utils';
import RecoverPasswordFlow from '@/modules/auth/components/RecoverPasswordFlow';
import Layout from '@/modules/core/components/Layout';

const RecoverPassword = () => (
  <div className="flex -ml-2 md:ml-0 pt-40 md:pt-16 max-w-screen h-[calc(100vh_-_48px)]">
    <span className="m-auto">
      <RecoverPasswordFlow />
    </span>
  </div>
);

export default RecoverPassword;

// Dynamic layout configuration
RecoverPassword.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};

// Server side code and i18n
export const getServerSideProps: GetServerSideProps = async ({
  locale,
}): Promise<GetServerSidePropsResult<SSRConfig>> => ({
  props: cleanObject({
    ...(await serverSideTranslations(locale || 'en')),
  }),
});
